// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__7In-j","info":"PatientInfo_info__2LYqo"};